import React, { Component, Context, CSSProperties } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import debounce from "lodash.debounce";
import { IAppState, mapAppStateToProps } from "../../redux/reducers/app";
import { IAppActionDispatches, mapAppDispatchToProps, IAppStoreProps } from "../../redux/actions/app";
import Nav, { NavProps } from "./Nav";
import AuthSignIn, { AuthSignInProps } from "../auth/ui/AuthSignIn";
import Logo from "./Logo";
// import PageHeading from "./PageHeading";
import { ISitePage } from "../../laco-common/base/models/page";
import { Widget } from "../widgets";
import LayoutContext, { ILayoutContext } from "../../contexts/layout/LayoutContext";
import { ImageWithLayersBG } from "../ui/Media/ImageWithLayersBG";
import DescriptionTextWeb from "../ui/DescriptionTextWeb";
import homeFirefighters from "../../assets/tempImages/firefightersHome.jpeg";
import "./Header.scss";

type HeaderProps = {
	isSimpleHeader?: boolean;
	fullWidth?: boolean;
	logoSrc?;
	navProps?: NavProps;
	authSignInProps?: AuthSignInProps;
	omitSignIn?: boolean;
	children?: React.ReactNode;
};

class Header extends Component<RouteComponentProps & IAppStoreProps & HeaderProps> {
	static contextType: Context<ILayoutContext> = LayoutContext;
	private readonly handleScroll = debounce(this.onScroll.bind(this), 5, { trailing: true });
	private collapseHeader = this.props.isSimpleHeader || this.props.activePage?.collapseHeader;

	componentDidMount() {
		this.initCollapseHeader();
	}

	componentWillUnmount() {
		if (this.context.settings.isDesktopRes) this.removeScrollEvt();
	}

	componentDidUpdate(prevProps: HeaderProps & IAppStoreProps, prevState, snapshot) {
		console.log("prevProps.activePage, this.props.activePage", prevProps.activePage, this.props.activePage);
		if (
			prevProps.activePage?.collapseHeader !== this.props.activePage?.collapseHeader ||
			prevProps.activePage?.id !== this.props.activePage?.id
		) {
			this.collapseHeader = this.props.isSimpleHeader || this.props.activePage?.collapseHeader;
			this.initCollapseHeader();
		}
	}

	initCollapseHeader() {
		if (!this.context.settings.isDesktopRes) return;
		if (this.collapseHeader) {
			this.removeScrollEvt();
		} else {
			this.addScrollEvt();
		}
		this.setCollapseHeader(this.collapseHeader);
	}

	addScrollEvt() {
		if (!this.context.settings.isDesktopRes) return;
		window.addEventListener("scroll", this.handleScroll);
	}

	removeScrollEvt() {
		if (!this.context.settings.isDesktopRes) return;
		window.removeEventListener("scroll", this.handleScroll);
	}

	onScroll(e) {
		this.setCollapseHeader(window.scrollY > 50);
	}

	setCollapseHeader(val: boolean) {
		this.collapseHeader = val;
		if (this.collapseHeader) {
			document.querySelector("header").classList.add("header-collapse");
			document.querySelector("header .header-collapse-after").classList.remove("d-none");
		} else {
			document.querySelector("header").classList.remove("header-collapse");
			document.querySelector("header .header-collapse-after").classList.add("d-none");
		}
	}

	renderHeaderButtons() {
		switch (this.props.activePage.id) {
			case "home": {
				return (
					<>
						<NavLink to="/peer-support" className="d-inline-block flex-grow-1 flex-md-grow-0 mr-2">
							<button className="btn btn-info w-100">Get Support</button>
						</NavLink>
						<NavLink to="/donate" className="d-inline-block flex-grow-1 flex-md-grow-0">
							<button className="btn btn-primary w-100">Donate</button>
						</NavLink>
					</>
				);
				break;
			}
			case "membersBenefits": {
				return (
					<NavLink to="/login">
						<button className="btn btn-primary">Member Login</button>
					</NavLink>
				);
				break;
			}
			default: {
				return null;
			}
		}
	}
	renderHeaderContent() {
		const page: ISitePage = this.props.activePage;
		if (!page) return null;

		// if (page.headerWidget) {
		// 	return <Widget widget={{ id: page.headerWidget, widgetType: page.headerWidget }} page={page} />;
		// }

		return (
			<div
				className={clsx(
					"header-title-content-inner",
					page.headerInnerImage ? "d-flex flex-column flex-md-row align-items-center" : "no-inner-image"
				)}
			>
				<div className="header-text-container">
					{!page.hidePageTitle && (
						<h1 className="highlighted">
							<span className="d-inline-block animated fadeInUp fast-1" key={page.title}>
								{page.title}
							</span>
						</h1>
					)}
					{!!page.headline && (
						<p className="header-headline pt-3">
							<DescriptionTextWeb text={page.headline} />
						</p>
					)}
					<div className="header-buttons d-flex flex-row justify-content-center justify-content-md-start">
						{this.renderHeaderButtons()}
					</div>
				</div>
				{!!page.headerInnerImage && (
					<div className="header-inner-image section-padding">
						{page.id === "home" ? (
							<ImageWithLayersBG url={page.id === "home" ? homeFirefighters : page.headerInnerImage} />
						) : (
							<img src={page.headerInnerImage} />
						)}
					</div>
				)}
			</div>
		);
	}

	render() {
		const { activePage, isSimpleHeader } = this.props;
		// console.debug("Header.render() this.props.activePage", this.props.activePage);
		// const isHomePage: boolean =
		// 	!!this.props.activePage && this.props.activePage.path === "" && this.props.activePage.id === "home";
		const hasHeaderWidget: boolean = !!activePage?.headerWidget;
		const hasEditorHeaderWidget: boolean = activePage?.headerWidget === "editor-content";

		const bgImgStylesOverride: CSSProperties = {};
		const headerImage1: string =
			// (this.props.activePage as any)?.headerImage || // simba
			activePage?.headerImage1 || this.props.headerImage1;

		if (!isSimpleHeader && headerImage1) {
			bgImgStylesOverride.backgroundImage = `url("${headerImage1}")`;
			if (activePage.positionY) {
				bgImgStylesOverride.backgroundPositionY = activePage.positionY;
			}
		}
		const inverted: boolean = this.props.activePage?.invertColors;

		return (
			<>
				<div
					className={clsx(
						"header-container position-relative d-flex flex-column",
						inverted && "light-mode",
						hasHeaderWidget && !hasEditorHeaderWidget && "header-home",
						hasEditorHeaderWidget && "header-with-editor-content",
						!isSimpleHeader && "site-header",
						!!headerImage1 && "has-image",
						(isSimpleHeader || activePage?.collapseHeader) && "simple-header",
						this.props.omitSignIn && "no-sign-in"
					)}
				>
					{!!headerImage1 && <div className="header-img-bg" style={bgImgStylesOverride} />}
					<header className={clsx("container-fluid", this.collapseHeader && "header-collapse")}>
						<div
							className={clsx(
								"header-inner-container d-flex flex-row justify-content-lg-between align-items-stretch",
								this.props.fullWidth ? "container-fluid pl-3" : "container"
							)}
						>
							<div className="logo-container mr-auto-xl-down">
								<Logo src={this.props.logoSrc} white={inverted} />
							</div>
							{this.props.children}
							<Nav {...this.props.navProps} white={inverted} />
							{!this.props.omitSignIn && (
								<AuthSignIn lightMode={inverted} {...this.props.authSignInProps} />
							)}
						</div>
						<span className="header-collapse-after d-none" style={bgImgStylesOverride}></span>
					</header>
					<div className="header-title-content container-fluid align-self-stretch flex-grow-1 flex-column justify-content-center">
						<div className="container">{!isSimpleHeader && this.renderHeaderContent()}</div>
					</div>
					{!isSimpleHeader &&
						hasHeaderWidget &&
						(this.context.settings.isDesktopRes || hasEditorHeaderWidget) && (
							<Widget
								widget={{
									id: this.props.activePage.headerWidget,
									widgetType: this.props.activePage.headerWidget,
								}}
								page={this.props.activePage}
								inHeader={true}
							/>
						)}
				</div>
				{!isSimpleHeader && hasHeaderWidget && !this.context.settings.isDesktopRes && !hasEditorHeaderWidget && (
					<Widget
						widget={{
							id: this.props.activePage.headerWidget,
							widgetType: this.props.activePage.headerWidget,
						}}
						page={this.props.activePage}
						inHeader={true}
					/>
				)}
			</>
		);
	}
}

const HeaderWithRouter = withRouter(Header);
export default connect<IAppState, IAppActionDispatches, HeaderProps>(
	mapAppStateToProps,
	mapAppDispatchToProps
)(HeaderWithRouter);
